import { Button, Field, TextField, Autocomplete, Text } from "components/commons";
import { InputAmount, SelectShiftsPaginated } from "components/field";
import styles from "./expense-details.module.scss";
import { useFormContext } from "contexts/form-context";
import { FormMode, Path } from "enums";
import locale from "localization";
import { expenseType } from "data/constant/expense-type";
import { rebateType } from "data/constant/rebate-type";
import { useRouter } from "hooks";
import { useState } from "react";
import SelectMultipleFiles, {
  extractDirectoryWithFile,
} from "components/commons/select-file/select-multiple-files";
import { isString } from "lodash";
import { Chip } from "@material-ui/core";
import { ShiftStatus } from "enums";
import Validation from "utils/validation.utils";

const ExpenseForm = ({ loading, expense }) => {
  const { formMode, fields, modifyField, isFormSubmittable, modifyForm } = useFormContext();
  const router = useRouter();
  const isAdd = formMode === FormMode.Add;
  const isEdit = formMode === FormMode.Edit;
  const [errorFile, setErrorFile] = useState(false);

  const onChangeExpenseType = (name, value) => {
    modifyForm({
      [name]: {
        value: value,
      },
      rebateType: {
        required: value === locale.nonInventoryItemRebates,
        validations: value === locale.nonInventoryItemRebates ? [Validation.required()] : [],
      },
      referenceNumber: {
        required: value === locale.nonInventoryItemRebates,
        validations: value === locale.nonInventoryItemRebates ? [Validation.required()] : [],
      },
    });
  };

  return (
    <div className={styles.form}>
      <Field {...fields.shiftId} label={locale.shift} childrenClassName={styles.shiftField}>
        <SelectShiftsPaginated
          {...fields.shiftId}
          disableAllOption
          shiftStatus={[ShiftStatus.Ended]}
          onChange={modifyField}
          placeholder={locale.selectShift}
          isHideBankDeposit={false}
        />
      </Field>
      <Field {...fields.type} label={locale.expenseType} childrenClassName={styles.fieldContent}>
        <Autocomplete
          {...fields.type}
          onChange={(name, { value }) => {
            onChangeExpenseType(name, value);
          }}
          options={expenseType}
          Component={Autocomplete}
        />
      </Field>
      {fields?.type?.value === locale.nonInventoryItemRebates && (
        <>
          <Field
            {...fields.rebateType}
            label={locale.rebateType}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              {...fields.rebateType}
              onChange={modifyField}
              options={rebateType}
              Component={Autocomplete}
            />
          </Field>
          <Field
            {...fields.referenceNumber}
            label={locale.referenceNumber}
            style={{
              width: "250px",
            }}
          >
            <TextField {...fields?.referenceNumber} onChange={modifyField} />
          </Field>
        </>
      )}
      <Field
        {...fields.amount}
        label={locale.amount}
        message={<locale.Populate items={["14"]} text={locale.maximumDigitsAndDecimalPlaces} />}
        style={{
          width: "250px",
        }}
      >
        <InputAmount {...fields.amount} onChange={modifyField} Component={InputAmount} />
      </Field>
      <Text color={"black"} strong style={{ fontSize: "16px" }}>
        {locale.receipt}
      </Text>
      <Text subtitle color="black">
        {locale.maxFileSize5MB}
      </Text>
      <Field {...fields.slip} childrenClassName={styles.fieldContent}>
        <SelectMultipleFiles
          {...fields.slip}
          maxFiles={5}
          multiple={true}
          onChange={(name, props) => {
            setErrorFile(props?.error);
            modifyField(name, { value: props });
          }}
          onClick={() => {
            setErrorFile("");
          }}
          renderResult={() => {
            const values = Array.isArray(fields?.slip?.value)
              ? fields?.slip?.value
              : [fields?.slip?.value];

            return values.filter(Boolean).map((file, index) => {
              const label = isString(file) ? extractDirectoryWithFile(file) : file?.name;

              return (
                <Chip
                  key={index}
                  label={label}
                  title={label}
                  style={{
                    backgroundColor: "#eae8ff",
                    color: "#5349b7",
                    fontWeight: "500",
                    maxWidth: "300px",
                    marginBottom: 4,
                  }}
                  onDelete={() => {
                    const updated = fields?.slip?.value?.filter?.((_, i) => i !== index) || [];
                    modifyField(fields.slip.name, {
                      value: updated.length ? updated : null,
                    });
                  }}
                  size="small"
                />
              );
            });
          }}
          errorFileFormatMessage={locale.failedToUploadImage}
          errorStyle={{
            width: "320px",
          }}
          maxSizeKb={5000}
          isView={formMode === FormMode.View}
        />
      </Field>
      <Field {...fields.remarks} label={locale.remarks}>
        <TextField multiline {...fields?.remarks} onChange={modifyField} />
      </Field>
      <div style={{ display: "flex", gap: "1em" }}>
        {isEdit && (
          <Button variant="outlined" onClick={() => router.push(Path.Expense)} loading={loading}>
            {locale.cancel}
          </Button>
        )}
        {(isAdd || isEdit) && (
          <Button
            type="submit"
            primary
            disabled={!isFormSubmittable || loading || errorFile}
            loading={loading}
          >
            {isEdit ? locale.saveChanges : locale.submit}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ExpenseForm;
